import styled from "styled-components";

export const Container = styled.div``;

export const ContinarModal = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  padding-bottom: 54px;

  white-space: pre-line;

  > h4 {
    /* font-family: AvertaPE; */
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.15px;
    color: #1b2852;
    margin-bottom: 24px;
  }

  > p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: #69769b;
    margin-bottom: 36px;
  }

  ::-webkit-input-placeholder {
    text-align: center;
  }

  :-moz-placeholder {
    /* Firefox 18- */
    text-align: center;
  }

  ::-moz-placeholder {
    /* Firefox 19+ */
    text-align: center;
  }

  :-ms-input-placeholder {
    text-align: center;
  }

  button {
    margin-top: 32px;
  }

  .containerButton {
    text-align: center;
  }
`;

export const ContainerInputsModal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 23px;
`;
